import styled from "styled-components";
import { theme } from "../../theme";

export const StyledDecisionReview = styled.div`
	display: flex;

	& > * > * {
		& > *:first-child {
			margin-bottom: 2rem;
		}
	}

	& h5 {
		width: 100%;
	}

	& .review {
		width: 100%;

		& span {
			text-transform: uppercase;
			font-weight: 500;
			font-size: 0.8rem;
			font-family: ${theme.font.secondary};
		}

		h5 {
			font-weight: 500;
			font-size: 1.2rem;

			font-family: ${theme.font.secondary};

			display: flex;
			align-items: center;
			column-gap: 0.5rem;
		}

		& i {
			display: flex;
			height: min-content;
			width: min-content;

			& img {
				height: 1.7rem;
			}
		}
	}
`;

export const StyledDecisionReviewModal = styled.div`
	display: flex;
	column-gap: 2%;

	& > * {
		width: 34%;
	}

	& > *:nth-child(2) {
		width: 24%;
	}

	& input {
		font-size: 1.2rem;
	}

	& label {
		display: flex;
		flex-direction: column;
		row-gap: 0.5rem;
	}
`;

export const StyledDecisionReviewBlock = styled.div`
	min-width: 20rem;
	height: min-content;
	padding: 1.5rem 1.8rem;
	margin-right: 1.1rem;

	background-color: white;
	border-radius: 0.4rem;

	position: relative;

	& > span:first-child {
		position: absolute;
		top: 1rem;
		right: 1rem;
	}

	& h2 {
		margin-bottom: 1.8rem;

		font-size: 1.8rem;
		font-weight: 700;
	}

	& .review > div {
		margin-bottom: 1.2rem;
	}

	& h6 {
		font-weight: 500;
	}
`;
